import { GradientButton as e } from "../../../components/button/button.mjs";
import { StarsIcon as t } from "../../../icons/stars-icon.mjs";
import "react";
import { twMerge as n } from "tailwind-merge";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/modules/widget/components/ai-chat-button.tsx
var a = ({ className: a, onClick: o, disabled: s }) => /* @__PURE__ */ r(e, {
	className: n("min-h-6.5 h-6.5 gap-0 rounded-sm border-none px-2 py-0 text-base font-bold", a),
	onClick: o,
	disabled: s,
	children: /* @__PURE__ */ i("div", {
		className: "flex items-center",
		children: [/* @__PURE__ */ r(t, {
			className: "h-5 w-5",
			color: "currentColor"
		}), /* @__PURE__ */ r("span", { children: "AI Chat" })]
	})
});
//#endregion
export { a as AiChatButton };
